module.exports = __webpack_public_path__ + "static/img/onlineserve.8bae15b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/onlineserve.jpeg
// module id = L+s+
// module chunks = 0